import { VERSION } from "../environment";

export const useAppVersion = (): string => VERSION;
